module.exports = __webpack_public_path__ + "img/value3.71166266.svg";